// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/build/src/models/addEditSampleModel';
import model_2 from '/build/src/models/batchCutedModel';
import model_3 from '/build/src/models/commonModel';
import model_4 from '/build/src/models/filterUserListModel';
import model_5 from '/build/src/models/ottScrollScreen';
import model_6 from '/build/src/models/preOrderDataModel';
import model_7 from '/build/src/models/useCommonModel';
import model_8 from '/build/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'addEditSampleModel', model: model_1 },
model_2: { namespace: 'batchCutedModel', model: model_2 },
model_3: { namespace: 'commonModel', model: model_3 },
model_4: { namespace: 'filterUserListModel', model: model_4 },
model_5: { namespace: 'ottScrollScreen', model: model_5 },
model_6: { namespace: 'preOrderDataModel', model: model_6 },
model_7: { namespace: 'useCommonModel', model: model_7 },
model_8: { namespace: '@@initialState', model: model_8 },
} as const
